export default "__VITE_ASSET__DQiP67uY__"